import React from "react";
import "./App.css";
import Nav from "./Nav.jsx";

module.exports = function App(props) {
  return (
    <div>
      <Nav />
      {props.children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/App.js